import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from 'styled-components';
import { useWindowSize } from '@miro-site/core';
import { useLocalization } from '@miro-site/localization';
import { isBoardExist, isBoardInitiated } from '../utils/checkBoardCookies';
import { useUserProfile } from './useUserProfile';
export var editableTemplatesConfig = {
  'o9J_l37TsCE=': {
    img: 'App_Wireframe',
    enabled: true
  },
  'uXjVPDq0Quo=': {
    img: 'Annual_Calendar',
    enabled: true
  },
  'uXjVOWRRMS8=': {
    img: 'Bar_Graph',
    enabled: true
  },
  'o9J_kmWuQco=': {
    img: 'Basic_Presentation',
    enabled: true
  },
  'o9J_kmWpOjY=': {
    img: 'Brand_Guidelines',
    enabled: true
  },
  'uXjVO3K7eK0=': {
    img: 'Burndown_Chart',
    enabled: true
  },
  'o9J_lVFCq5k=': {
    img: 'Business_Organizational_Chart',
    enabled: true
  },
  'o9J_klb8Byw=': {
    img: 'Buyer_Persona',
    enabled: true
  },
  'o9J_kwDh-tU=': {
    img: 'Communications_Plan',
    enabled: true
  },
  'o9J_lyX-4-c=': {
    img: 'Company_Organizational_Chart',
    enabled: true
  },
  'o9J_lyQaDuE=': {
    img: 'Daily_Standup',
    enabled: false
  },
  'o9J_kwDh-o0=': {
    img: 'Design_Brief',
    enabled: true
  },
  'o9J_kwggNsU=': {
    img: 'Effort_Impact',
    enabled: true
  },
  'uXjVOtl9Va4=': {
    img: 'Entity_Relationship_Diagram',
    enabled: true
  },
  'o9J_kheyRIM=': {
    img: 'Event_Planning',
    enabled: false
  },
  'o9J_kknzqdQ=': {
    img: 'Floor_Plan',
    enabled: true
  },
  'o9J_lYWigMg=': {
    img: 'Flowchart',
    enabled: true
  },
  'o9J_lsq4Lgk=': {
    img: 'Gantt_Chart',
    enabled: true
  },
  'o9J_k0A84fk=': {
    img: 'Lean_Canvas',
    enabled: true
  },
  'uXjVO3BxCN4=': {
    img: 'Meet_the_Team',
    enabled: true
  },
  'o9J_kzZ-hxs=': {
    img: 'Mindmap',
    enabled: true
  },
  'o9J_km-cqgg=': {
    img: 'OKR',
    enabled: true
  },
  'o9J_lxY7ixM=': {
    img: 'One-on-one_Meeting',
    enabled: true
  },
  'o9J_kw5oiFY=': {
    img: 'Organizational_Chart',
    enabled: true
  },
  'o9J_kw8wLFM=': {
    img: 'Process_Map',
    enabled: true
  },
  'o9J_klb14Nc=': {
    img: 'Product_Canvas',
    enabled: true
  },
  'o9J_lyX2d04=': {
    img: 'Product_Roadmap',
    enabled: true
  },
  'o9J_lFtEhZo=': {
    img: 'Project_Charter',
    enabled: false
  },
  'o9J_klbw2uY=': {
    img: 'Project_Scope',
    enabled: true
  },
  'o9J_km-Irso=': {
    img: 'Prototype',
    enabled: false
  },
  'uXjVOCSXLBo=': {
    img: 'RACI_Matrix',
    enabled: true
  },
  'o9J_klb-CHE=': {
    img: 'Risk_Assessment',
    enabled: true
  },
  'o9J_k06s5bk=': {
    img: 'Sitemap',
    enabled: true
  },
  'o9J_k0H_AWo=': {
    img: 'SMART_Goals',
    enabled: true
  },
  'o9J_l36jZQs=': {
    img: 'Storyboard',
    enabled: false
  },
  'o9J_k0ACo4w=': {
    img: 'Strategy_Map',
    enabled: true
  },
  'uXjVO1EPvok=': {
    img: 'SWOT_Analysis',
    enabled: false
  },
  'o9J_l4G9GpM=': {
    img: 'Team_Charter',
    enabled: true
  },
  'o9J_kiyvNfI=': {
    img: 'Technology_Roadmap',
    enabled: true
  },
  'o9J_k0ACzNI=': {
    img: 'To-do_List',
    enabled: true
  },
  'o9J_k0ACtSo=': {
    img: 'UML_Diagram',
    enabled: true
  },
  'o9J_k0ACqZ4=': {
    img: 'Use_Case_Diagram',
    enabled: true
  },
  'o9J_lnveXlI=': {
    img: 'User_Persona',
    enabled: true
  },
  'o9J_ki0kElE=': {
    img: 'UX_Research',
    enabled: true
  },
  'o9J_k0G0eac=': {
    img: 'Value_Stream',
    enabled: true
  },
  'o9J_lsqoKV4=': {
    img: 'Swimlane_Diagram',
    enabled: true
  },
  'uXjVO3Eb7FI=': {
    img: 'Competitive_Analysis',
    enabled: false
  },
  'o9J_lyX0K2A=': {
    img: 'Timeline_Template',
    enabled: false
  },
  'uXjVOZKb5dc=': {
    img: 'AWS_Architecture_Diagram',
    enabled: true
  },
  'o9J_k0ADM5M=': {
    img: 'KWL_Chart',
    enabled: true
  }
};
export var useEditableTemplateBoard = function useEditableTemplateBoard(embedBoardKey, config) {
  var _configExpanded$embed2, _configExpanded$embed3;

  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale;

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var theme = useTheme();

  var _useUserProfile = useUserProfile(),
      isUserRegistered = _useUserProfile.isUserRegistered,
      isProfileLoading = _useUserProfile.isProfileLoading;

  var isMobile = width ? width < theme.breakpoints.small : false;
  var isEnLocale = currentLocale === 'en';
  var configExpanded = Object.keys(config).reduce(function (acc, key) {
    if (!config[key].img) return acc;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, {
      on: config[key].enabled,
      name: config[key].img.replaceAll('_', ' '),
      image: "".concat(config[key].img, ".png")
    }));
  }, {});

  var isExperimentEnabled = function isExperimentEnabled() {
    var _configExpanded$embed;

    var isTemplateAvailable = !!((_configExpanded$embed = configExpanded[embedBoardKey]) !== null && _configExpanded$embed !== void 0 && _configExpanded$embed.on) && !isMobile && isEnLocale;
    var isRegisteredUser = isUserRegistered && !isProfileLoading;
    var isBoardActive = isBoardExist(embedBoardKey) && isBoardInitiated(embedBoardKey);

    if (isBoardActive && isTemplateAvailable) {
      return true;
    }

    if (isTemplateAvailable && isRegisteredUser) {
      return true;
    }

    return false;
  };

  return {
    isEditableTemplatesExperiment: isExperimentEnabled(),
    isEditableTemplateBoardActive: isBoardExist(embedBoardKey) && isBoardInitiated(embedBoardKey),
    editableTemplatePreview: {
      name: (_configExpanded$embed2 = configExpanded[embedBoardKey]) === null || _configExpanded$embed2 === void 0 ? void 0 : _configExpanded$embed2.name,
      original: {
        jpg: "".concat(process.env['NEXT_PUBLIC_ASSET_PREFIX'] || '', "/static/images/editable-templates/").concat((_configExpanded$embed3 = configExpanded[embedBoardKey]) === null || _configExpanded$embed3 === void 0 ? void 0 : _configExpanded$embed3.image)
      }
    }
  };
};